module.exports = __webpack_public_path__ + "static/media/detail7.7b3e15fb.jpg";